import ModalContext from 'contexts/ModalContext'
import React, { useCallback, useContext } from 'react'
import LineInfoCircleIcon from '../../../../../LuxKit/Icons/line/LineInfoCircleIcon'
import Label from '../../../../../LuxKit/Label'
import Modal from 'LuxKit/Modal/Modal'
import Group from 'components/utils/Group'
import OfferInclusionsList from 'components/Common/Inclusions/OfferInclusionsList'
import BodyText from 'LuxKit/Typography/BodyText'
import useOfferUrl from 'hooks/Offers/useOfferUrl'
import { EmptyObject } from '../../../../lib/object/objectUtils'
import Clickable from 'components/Common/Clickable'

interface Props {
  offer: App.Offer | App.OfferSummary | App.Tours.TourV2Offer | App.Tours.TourV2OfferSummary | App.CruiseOffer
  inclusions: Array<App.OfferInclusion>
  filters?: App.OfferListFilters
}

function ExperimentalHotelUpgradableInclusionsLabel(props: Props) {
  const {
    offer,
    inclusions,
    filters = EmptyObject,
  }: Props = props

  const showModal = useContext(ModalContext)

  const offerUrl = useOfferUrl(offer, { filters })

  const toggleModal = useCallback((event: React.MouseEvent) => {
    event.preventDefault()
    event.stopPropagation()

    showModal(
      <Modal
        title="Bonus inclusions on selected packages"
        primaryActionText="View offer"
        primaryActionTo={offerUrl}
      >
        <Group direction="vertical" gap={16}>
          <BodyText variant="medium">
            Get more from your stay with added inclusions when you book select packages
          </BodyText>
          <OfferInclusionsList
            inclusions={inclusions}
          />
        </Group>
      </Modal>,
    )
  }, [inclusions, offerUrl, showModal])

  return (
    <Clickable onClick={toggleModal}>
      <Label
        kind="primary"
        variant="highlight-secondary"
        endIcon={<LineInfoCircleIcon />}
      >
        Upgrade for bonus inclusions
      </Label>
    </Clickable>
  )
}

export default ExperimentalHotelUpgradableInclusionsLabel
